import { DateFormatter } from '@components'

import { Color, TableCellContent } from '@billy/design-system'
import { ReactElement } from 'react'

interface InvoiceDateCellProps {
  date: string | null | undefined
  isVoided: boolean
}

export const InvoiceDateCell = ({ date, isVoided }: InvoiceDateCellProps): ReactElement => {
  // The table cell already wraps its content in a paragraph, so this one renders as a block span to stay valid HTML.
  return (
    <TableCellContent as="span" color={isVoided ? Color.Grey300 : undefined} inline={false} truncate>
      {date && <DateFormatter value={date} />}
    </TableCellContent>
  )
}
